<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    include /@ibkr/lib.common/src/icon/arrow

    ib-progress-linear(class="_row grow", :class="{ signedin: signedIn, cp: ($router && $router.options.isPortal) }", :show="loading", blocking)
        ib-col(class="flex")
            ib-row
                ib-col(class="insetx-16 flex-fixed border-bottom border-xs")
                    div(v-if="this.total <= MAX_ROWS", class="fs7")
                        | {{ $t('showing') }} {{ total }} of {{ total }}
                    div(v-else, class="fs7")
                        | {{ $t('showing') }}
                        |  {{ curResults.length ?  $num.int((MAX_ROWS * (curPage - 1) + 1)) : 0 }}
                        |  to {{  $num.int(MAX_ROWS * (curPage - 1) + curResults.length) }}
                        |  of {{  $num.int(total) }}
                    ib-paginate(v-if="!loading", v-model="curPage", :stride="5", :size="5", :max="maxPage")
            ib-table-basic(
                row,
                class="fs7 fg70 shrink",
                :data="curResults",
                spacing="huge",
                ref="scrolltable",
                @click="openQD"
            )
                ib-table-col(:width="$media.m ? '36ch' : '20ch'", sticky) {{ $t('fund_name') }}
                ib-table-col(width="8ch") {{ $t('symbol') }}
                ib-table-col(width="24ch") {{ $t('fund_family') }}
                ib-table-col(width="12ch") {{ $t('fund_type') }}
                ib-table-col(width="12ch") {{ $t('transaction_fee') }}
                ib-table-col(width="10ch") {{ $t('load_type') }}
                ib-table-col(width="16ch") {{ $t('management_fees') }}
                ib-table-col(width="12ch") {{ $t('expense_ratio_%') }}
                ib-table-col(width="14ch") {{ $t('performance_ytd') }}
                ib-table-col(width="12ch") {{ $t('lipper_rating') }}
                ib-table-col(width="16ch") {{ $t('sharpe_ratio') }}
                ib-table-col(width="16ch") {{ $t('geographical_focus') }}
                ib-table-col(width="12ch") {{ $t('esg_score') }}
                ib-table-col(width="16ch") {{ $t('aum') }}
                ib-table-col(width="12ch") {{ $t('isin') }}
                ib-table-col(width="12ch") {{ $t('cusip') }}
                ib-table-col(width="14ch") {{ $t('share_class') }}
                ib-table-col(width="14ch") {{ $t('initial_invest') }}
                p(slot="empty", v-if="loading") {{ $t('loading') }} ...
                p(slot="empty", v-else) {{ $t('no_results') }}
                template(slot="body" slot-scope="row")
                    td(@click="getMoreInfo", class="ellipsis")
                        span(class="clipped fs7 fg70" :title="row.NAME") {{ row.NAME }}
                    td(@click="getMoreInfo")
                        span(:title="row.SYMBOL") {{ row.SYMBOL }}
                    td(@click="getMoreInfo")
                        span(class="ellipsis no-wrap", :title="row.FAMILY") {{ row.FAMILY}}
                    td(@click="getMoreInfo")
                        span(:title="row.INVEST_TYPE") {{ row.INVEST_TYPE }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.TXN }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.LT }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.MGTFEE }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.EXPENSE_RATIO }}
                    td(v-if="!signedIn" class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.PERF }}
                    td(v-if="!signedIn", class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.LIPPER }}
                    td(v-if="!signedIn", class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.SHARPE }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.FUND_GEO }}
                    td(v-if="!signedIn", class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.ESG }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.ASSETS }}
                    td(v-if="!signedIn", class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.ISIN }}
                    td(v-if="!signedIn", class="blue", @click="getMoreInfo") {{ $t('login_to_view') }}
                    td(v-else) {{ row.CUSIP }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.SHARE_CLASS }}
                    td(class="text-center", @click="getMoreInfo")
                        span {{ row.INITIAL_INVEST }} 
                //-- lib.common adds empty column even when the condition for template for slot="end" is false,
                //-- so i made prop "slot" conditional to avoid this issue until it's fixed in lib.common
                template(
                    v-if="$router && $router.options.isPortal",
                    :slot="$router && $router.options.isPortal? 'end' :''",
                    slot-scope="row"
                )
                    span
                        ib-button(
                            tone="accent capitalize",
                            @click="trade(formattedRow(row), true)"
                        ) {{ $t('buy') }}
                        ib-button(
                            tone="sell capitalize",
                            @click="trade(formattedRow(row), false)"
                        ) {{ $t('sell') }}
                        ib-button(
                            class="outline accent capitalize",
                            @click="addToWatchlist(formattedRow(row))"
                        ) {{ $t('watchlist') }}

        ib-dialog(
            :autoclose="true",
            ref="modal",
            v-model="showLoginScreen"
        )
            div(class="inner-modal")
                div(class="add-info flex-fixed top")
                    h3 {{ $t('mutual_fund_search') }}
                    a(@click="closeModal")
                        span(class="fg")
                            +icon-basic-cancel
                h5 {{ $t('login_to_portal_view_more_info') }}
                p(class="text-end inset-8")
                    ib-button(class="bg-accent _btn xs act", @click.prevent="addFilters") {{ $t('have_an_existing_account') }}
                h5 {{ $t('dont_have_an_account_open_one') }}
                p(class="text-end inset-8")
                    a(class="bg-accent _btn xs act" href="https://www.interactivebrokers.com/en/index.php?f=4695") {{ $t('open_an_ib_account') }}
</template>

<script>
    import api from '../api/'
    import { Settings } from '@ibkr/clientportal.common/src/js/settings'
    const MAX_ROWS = 50;
    const sso = 'https://www.interactivebrokers.com/sso/Login?action=FUNDSCANNER';

    export default {
        name: 'SearchResults',

        created() {
            this.$overlay = window.Vue.prototype.$overlay;
            this.checkSignedIn();
        },

        computed: {
            conids() {
                return this.curResults.map(m => parseInt(m.CONID));
            },
        },

        props: {
            scanFields: Object
        },

        data() {
            return {
                amSession: window.AM_SESSION_ID,
                curPage: 1,
                curResults: [],
                loading: true,
                maxPage: 1,
                MAX_ROWS: MAX_ROWS,
                query: '',
                results: [],
                signedIn: false,
                total: 0,
                firstLoad: true,
                showLoginScreen: false
            }
        },

        methods: {
            addFilters() {
                this.query = new URLSearchParams(this.scanFields).toString();
                window.location.href = `${sso}&${this.query}`;
            },

            checkSignedIn() {
                if (this.$router?.options.isPortal) {
                    this.signedIn = true;
                    this.$emit('signedIn', this.signedIn);
                } else if (typeof amSession !== 'undefined') {
                    this.signedIn = true;
                    this.$emit('signedIn', this.signedIn);
                } else {
                    api.checkCP()
                        .then(res => {
                            if (res && res["RESULT"] === true) {
                                this.signedIn = true;
                                this.$emit('signedIn', this.signedIn);
                            }
                        })
                        .catch(error => {
                            console.debug(error);
                            this.$emit('signedIn', this.signedIn);
                        })
                }
            },

            closeModal() {
                this.showLoginScreen = false;
            },

            getMoreInfo() {
                if (!this.signedIn) {
                    this.showLoginScreen = true;
                }
            },

            refresh() {
                this.showLoginScreen = false;
                this.curPage = this.scanFields.page ? this.scanFields.page : 1;
                this.curResults = [];
                this.maxPage = 1;
                this.results = [];
                this.total = 0;
                this.search();
                window.scrollTo(0,0);
            },

            search() {
                this.loading = true;
                for (const field in this.scanFields) {
                    if (this.scanFields[field] === 'All') {
                        this.scanFields[field] = '';
                    }
                }
                if (!this.scanFields['page'] || !this.firstLoad ) {
                    this.scanFields['page'] = this.curPage;
                }
                api.searchFunds(this.scanFields)
                    .then((res) => {
                        res = res.data;
                        if (res.total === 0) {
                            this.$alert(this.$t('zero_results'));
                            this.loading = false;
                            return;
                        }
                        this.total = res.total;
                        this.results = Object.values(res.funds);
                        this.results.forEach((result) => {
                            let numTest = /\d/.test(result['SYMBOL']);
                            for (const key in result) {
                                if (!result[key]) {
                                    result[key] = 'N/A';
                                }
                            }
                            if (numTest) { result['SYMBOL'] = 'N/A' }
                        });
                        if(this.total > MAX_ROWS) {
                            this.maxPage = Math.ceil(this.total/MAX_ROWS);
                        }
                        this.curResults = this.results.length <= MAX_ROWS ? this.results
                            : this.results.slice(MAX_ROWS * (this.curPage - 1), MAX_ROWS * this.curPage);

                        this.loading = false;
                    })
                    .catch(error => {
                        console.error(error);
                        this.loading = false;
                        this.$alert(this.$t('not_available'));
                    });
            },

            formattedRow(row){
                row.conid = parseInt(row.CONID);
                return row;
            },

            //--open Quote details page when in CP
            openQD(data) {
                const conid = data && data.row && data.row.CONID;
                if (conid && this.$router?.options.isPortal) {
                    Settings.store('context_conids', this.conids);
                    this.$router.push({
                        path: '/quote',
                        query: {
                            source: 'mf',
                            conid
                        }
                    });
                }
                if (conid && typeof amSession !== 'undefined') {
                    this.$router.push({
                        path: '/quote',
                        query: {
                            source: 'mf',
                            conid
                        }
                    });
                }
            },

            addToWatchlist(pos) {
                if (pos.conid) {
                    window.app.addToWatchlist(pos.conid);
                }
            },

            trade(row, buy) {
                window.onebar.openQuickTradeV2({ conid: row.conid, isBuy: buy, referrer: '' });
            }
        },

        mounted() {
            this.refresh();
            this.firstLoad = false;
        },

        watch: {
            scanFields: {
                handler: function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.search();
                    }
                },
                deep: true,
                immediate: true
            },

            curPage: {
                handler: function(newVal, oldVal) {
                    window.scrollTo(0,0);
                    if (newVal !== oldVal) {
                        this.loading = true;
                        this.results = [];
                        this.search();
                    }
                }
            },

            conids: {
                handler(val) {
                    if(this.$router?.options.isPortal && val && val.length > 0) {
                        this.$store.dispatch('getSecdefs', { conids: val });
                    }
                },
                immediate: true
            }
        },
 }
</script>

<style lang="less">
a:not([href]):not([tabindex]) {
    color: inherit;
    text-decoration: none;
}

.inner-modal {
    width: 100%;
    border-top: 0.25rem solid #db1222;
    padding: 10px; 
    .act {
        background: #db1222;
        border-radius: 0;
    }
    .add-info {
        h3 {
            display: inline-block;
            padding: 10px 0;
        }
    }
}

.resultsview {
    &.signedin:not(.cp) {
        .scroll-table {
            td {
                cursor: default;
            }
        }
    }
}
</style>
